import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/v1/";

const getAuthHeaders = () => {
  const token = localStorage.getItem("access_token");
  return {
    accept: "application/json",
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

/**
 * 1. User Targets CRUD APIs
 */
export const fetchTargets = async (params = {}) => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/targets`, {
      params,
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const createTarget = async (payload) => {
  try {
    const response = await axios.post(`${BASE_URL}dashboard/targets`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const updateTarget = async (targetId, payload) => {
  try {
    const response = await axios.put(`${BASE_URL}dashboard/targets/${targetId}`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const deleteTarget = async (targetId) => {
  try {
    const response = await axios.delete(`${BASE_URL}dashboard/targets/${targetId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * 2. Health Metrics API
 */
export const fetchHealthMetrics = async () => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/health-metrics`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * 3. Syllabus Progress API
 */
export const fetchSyllabusProgress = async () => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/syllabus-progress`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * 4. Milestone Counters API
 */
export const fetchMilestones = async () => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/milestones`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * 5. Study Contributions Heatmap API
 */
export const fetchStudyHeatmap = async () => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/study-heatmap`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * 6. Active Promotion API (PromoDrawer)
 */
export const fetchActivePromotion = async () => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/promotion`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * 6b. Active Seasonal / Festive Theme API (Homepage Banner)
 */
export const fetchActiveTheme = async () => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/theme`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * 7. Revision Queue & Weakness Spotlight API
 */
export const fetchRevisionWeakness = async () => {
  try {
    const response = await axios.get(`${BASE_URL}dashboard/revision-weakness`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};


